import { Container, Row, Col, Spinner, Alert } from 'react-bootstrap';
import MainLayout from '../../../layouts/MainLayout';
import { T } from "../../../helpers/Language";
import SuppliesForm from '../../../components/FFDA/Supplies/SuppliesForm';
import SuppliesList from '../../../components/FFDA/Supplies/SuppliesList';
import { 
    Supply as SupplyAPI,
    Supplies as SuppliesAPI,
    Entity as EntityAPI
} from '../../../api';
import { useEffect, useState } from 'react';
import SuppliesOrderModal from '../../../components/FFDA/Supplies/SuppliesOrderModal';
import { connect } from 'react-redux';
import './Supplies.scss';

const Supplies = ({
    session
}) => {
    const [isInitialized, setIsInitialized] = useState(false);
    const [supplyMap, setSupplyMap] = useState({});
    const [suppliesOrders, setSuppliesOrders] = useState({});
    const [clientAddresses, setClientAddresses] = useState([]);
    const [selectedSuppliesOrder, setSelectedSuppliesOrder] = useState(null);

    useEffect(() => {
        const init = async () => {
            try {
                const promises = [
                    SupplyAPI.getSupplyList(),
                    SuppliesAPI.getSupplies(),
                    EntityAPI.getEntityById(session.currentVirtualAccount)
                ];

                const result = await Promise.all(promises);
                const supplyMap = result[0]?.reduce((acc, supply) => {
                    acc[supply.id] = supply;
                    return acc;
                }, {});
                setSuppliesOrders(result[1]);
                setSupplyMap(supplyMap);
                const addressesRes = result[2]?.data?.addresses || [];
                setClientAddresses(addressesRes);
                setIsInitialized(true);
            } catch (err) {
                console.log(err);
            }
        };

        if (!isInitialized) {
            init();
        }
    }, [isInitialized]);

    const onSubmit = async (data) => {
        try {
            const newOrder = await SuppliesAPI.orderSupplies(data);
            const newSupplies = [newOrder, ...suppliesOrders];
            setSuppliesOrders(newSupplies);
        } catch (err) {
            throw err;
        }
    }

    const handleSelectSuppliesOrder = (suppliesOrder) => {
        setSelectedSuppliesOrder(suppliesOrder);
    }

    return (
        <MainLayout pageTitle={T("SUPPLIES_TITLE")}>
            <Container>
                <Row className="mt-3 justify-content-center">
                    <Col lg={8} className="mt-2">
                        <Alert key={'info'} variant={'info'} className={"mt-3 mb-3 text-center"}>
                            <strong>IMPORTANT!</strong><br />
                            When you start your last pad of Funeral Purchase Contracts or your last Receipt Book...<br />
                            <strong>REORDER IMMEDIATELY!!</strong><br />
                            Allow 4 weeks for repeat orders • Allow 6 weeks for change orders.
                        </Alert>
                    </Col>
                </Row>
                <Row className="mt-3 justify-content-center">
                    <Col lg={6} className="mt-2">
                        {!isInitialized ? 
                                (<>
                                    <Spinner animation="border" role="status"></Spinner>
                                    <p>Loading available supplies...</p>
                                </>)
                            : 
                                <SuppliesForm supplyMap={supplyMap} clientAddresses={clientAddresses} onSubmit={onSubmit} />
                        }
                    </Col>
                    <Col lg={6} className="mt-2">
                        {!isInitialized ? 
                                (<>
                                    <Spinner animation="border" role="status"></Spinner>
                                    <p>Loading Orders...</p>
                                </>)
                            :
                                <SuppliesList 
                                    key={`list-${suppliesOrders.length}`}
                                    supplies={suppliesOrders}
                                    handleSelectSuppliesOrder={handleSelectSuppliesOrder}
                                />
                        }
                    </Col>
                </Row>
                {selectedSuppliesOrder && 
                    <SuppliesOrderModal selectedSuppliesOrder={selectedSuppliesOrder} setSelectedSuppliesOrder={setSelectedSuppliesOrder} />
                }
            </Container>
        </MainLayout>
    );
};

const mapStateToProps = (appState) => ({
    session: appState.session
});

export default connect(mapStateToProps)(Supplies);
